export default class PlayCount {
  static get selector() {
    return 'span.video-plays-count[data-loaded="false"]';
  }

  static get preloadedSelector() {
    return 'input.preloaded-plays-count[data-loaded="false"][type="hidden"]';
  }

  static ids(type) {
    if (type === undefined) return [];

    let ids = [];
    let elements = $(this.selector + '[data-type="' + type + '"]');
    elements.each(function() {
      ids.push($(this).data('id'));
      $(this).attr('data-loaded', true);
    });

    return ids;
  }

  static preloadIDs(type) {
    if (type === undefined) return [];

    let ids = [];
    let elements = $(this.preloadedSelector + '[data-type="' + type + '"]');
    elements.each(function() {
      ids.push($(this).data('id'));
      $(this).attr('data-loaded', true);
    });

    return ids;
  }

  static filterPreloadedIds(ids, preloadedIds) {
    return ids.filter(function(e){ return this.indexOf(e)<0; }, preloadedIds);
  }

  static loadIDs(type) {
    var filteredIds = this.filterPreloadedIds(this.ids(type), this.preloadIDs(type));
    return filteredIds.sort((a, b) => a - b);
  }

  static preloadData() {
    let response = [];
    let elements = $(this.preloadedSelector);

    elements.each(function(index, element) {
      let el = $(element);
      let resource = { id: el.data('id'), total: parseInt(el.val()), type: el.data('type') };
      response.push(resource);
    });

    return response;
  }

  static preload() {
    this.render(this.preloadData());
  }

  static load() {
    this.preload();

    let videoIDs = this.loadIDs('Video');
    let livestreamingIDs = this.loadIDs('Livestreaming');

    if (videoIDs.length > 0 || livestreamingIDs.length > 0) {
      $.get('/play_counts/video?video_ids=' + videoIDs.join(",") + '&livestreaming_ids=' + livestreamingIDs.join(",")).done(this.render);
    }
  }

  static render(response) {
    if(response !== undefined){
      var lang = $('meta[name=language]').attr('content');
      $.each(response, function(index, resource) {
        // NOTICE: bind.(this) doesn't work inside $.each, therefore we need to type in the whole selector instead of using this.selector
        let element = $('span.video-plays-count[data-id=' + resource.id + '][data-type=' + resource.type + ']');
        let textElement = resource.type == 'Video' ? window.Locale[lang].watch.plays : window.Locale[lang].livestreaming.watching;
        let realPlayCount = parseInt(resource.total);

        if(realPlayCount != 0){
          let playCountContent = realPlayCount.toString().toIndonesianNumber();
          playCountContent = playCountContent.shortenNumber();
          element.html('<span class="video-plays-count-value">' + playCountContent +'</span> ' + textElement);
        }
      });
    }
  }
}
